import { Category } from '../../../../core/lists';
import { FormSystem } from '../enums';

export class Form {
  constructor(
    public id = 0,
    public name = '',
    public teams: Category[] | number[] = null,
    public system: FormSystem = null,
    public schema = '',
    public version = 0,
    public compliance: { ids: number[]; is_edited?: boolean } = null,
    public field_synonym_value_map?: { [key: string]: { label: string; value: string }[] },
    public has_mappings?: boolean,
    public is_active?: boolean,
  ) {}
}
